export default "__VITE_ASSET__DPOQUg1D__"